import { createAsyncThunk } from '@reduxjs/toolkit';

import APIDataProvider, { TApiResponse } from '../../../api/ApiDataProvider';
import { ApiPaths } from '../../../api/APIPaths';
import { ICourse } from '../CoursesSlice';
import { ITrialClasses } from '.';
import { TUserSignUpRes } from '../../AuthSlice/AuthApi';

export interface TCreateTrial {
  curriculum: string;
  subject: string;
  grade: string;
  startDate: string;
  endDate: string;
  tutorId: string;
}

export interface ICreateTrialWithAccount extends TCreateTrial {
  name: string;
  email: string;
  phoneNumber: string;
  password: string;
  timezone: string;
  clientId: string;
  clientSecret: string;
  onboardingUserId?: string;
}

const apiDataProvider = new APIDataProvider();

export const createTrial = createAsyncThunk(
  '/trials/create',
  async (data: TCreateTrial) => {
    const path = `${ApiPaths.trials}`;
    const response = await apiDataProvider.post<TApiResponse<ICourse>>(
      path,
      data
    );

    return response.data;
  }
);

export const createTrialWithAccount = createAsyncThunk(
  '/trials/create-with-account',
  async (data: ICreateTrialWithAccount) => {
    const path = `${ApiPaths.trials}/sign-up`;
    const response = await apiDataProvider.post<TApiResponse<TUserSignUpRes>>(
      path,
      data
    );

    return response.data;
  }
);

export const getTrials = createAsyncThunk('/trials/getTrials', async () => {
  const path = `${ApiPaths.trials}`;
  const response = await apiDataProvider.get<TApiResponse<ITrialClasses>>(path);

  return response.data;
});
